import React from 'react';
import FilteredApprovalsComponent from '../FilteredApprovals';
import Heading from '@hubins/components/Heading';

const ApprovalsFilter = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>Filter</Heading>
      <FilteredApprovalsComponent />
    </>
  );
};

export default ApprovalsFilter;
